import { Skeleton } from '@material-ui/lab';

export default function GoalSkeleton() {
    let goalList = document.querySelector('.Page-goal-list')
    let goalNumber = 0
    if (goalList) {
        let width = goalList.clientWidth
        goalNumber = Math.floor(width / 294)
    }
        
    return (
        <div className="Page-goal-list">
            {
                [...Array(goalNumber)].map((e, i) => {
                    return <Skeleton variant="rect" width="100%" height="100%" key={i} />
                })
            }
        </div>
    )
}